import { useMemo } from 'react'
import { parsePinTypeCatalog, type PinTypeEntry } from '@wehunt/ui'
import { useRemoteConfigString } from '../../../shared/remoteConfig/useRemoteConfigString'

/** The Remote Config parameter mobile reads its pin-type catalog from. */
export const MAP_PIN_TYPES_RC_KEY = 'mapPinTypes2'

/**
 * The pin-type catalog entries from Remote Config. No bundled fallback: an
 * unreachable Remote Config on a cold cache yields an empty, ready catalog,
 * which is what mobile shows in the same situation.
 */
export function usePinTypeCatalogEntries(): { entries: PinTypeEntry[]; ready: boolean } {
  const { value, ready } = useRemoteConfigString(MAP_PIN_TYPES_RC_KEY)
  const entries = useMemo(() => parsePinTypeCatalog(value), [value])
  return { entries, ready }
}
